<!--Instagram URL List Page-->
<template>
  <v-container fluid>
      <v-card>
          <v-card-title class="d-flex justify-space-between">
              <span>Instagram Post On My Preschool Tab</span>
              <v-btn
                color="accent"
                dense
                small
                @click="openInstagramreelsDialog"
              >
                Add Instagram URL
              </v-btn>
              <AddInstagramReels
                :requestType="requestMode"
                :instagramDialog = "instagramDialog"
                :instagramItem = "instagramItem"
                :franchiseeID="franchiseeID"
                @closeInstagramReelsDialog="closeInstagramReelsDialog"
              />
          </v-card-title>
          <v-card-text>
              <v-data-table
                dense
                :headers="headers"
                :items="instagramList"
                class="elevation-0"
              >
                <template v-slot:item.action="{item}">
                  <v-btn @click="editInstaUrl(item)" dense color="accent" text small>
                    <v-icon left small>mdi-pencil</v-icon> Edit
                  </v-btn>

                  <v-btn  @click="deleteIstaUrl(item.id)" dense color="accent" text small>
                    <v-icon left small>mdi-delete</v-icon> Delete
                  </v-btn>
                </template>
              </v-data-table>
          </v-card-text>
      </v-card>
  </v-container>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import AddInstagramReels from '@/components/InstagramReels/addInstagramUrl.vue'
import { mapGetters } from 'vuex'
import Stores from '@/stores'
import Utils from '@/utils'
import moment from 'moment'

export default {
  name: 'AddEditInstagramReels',
  components: {
    AddInstagramReels
  },
  data: () => ({
    instagramDialog: false,
    instagramItem: null,
    instagramList: [],
    loadingComponent: null,
    headers: [
      { text: 'Sr No.', align: 'center', sortable: false, value: 'indexNo' },
      { text: 'Instagram URLs', align: 'center', value: 'instaUrls' },
      { text: 'Start Date & Time', align: 'center', value: 'startDateAndTime' },
      { text: 'End Date & Time', align: 'center', value: 'endDateAndTime' },
      { text: 'Franchise', align: 'center', value: 'franchiseeNameArray' },
      { text: 'Actions', align: 'center', value: 'action' }
    ],
    franchiseeID: null,
    requestMode: null
  }),
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee'
    })
  },
  watch: {
    franchisee: {
      handler: function (newVal) {
        if (newVal !== this.franchiseeID) {
          this.franchiseeID = newVal.id ? newVal.id : ''
        }
      },
      deep: true
    },
    franchiseeID: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (!newVal) {
          Utils.helper.openDrawer(this)
          this.instagramList = []
          return false
        }
        this.getInstagramUrlList(newVal)
      }
    }
  },
  async created () {
    let userData = await Stores.user
    if (userData.franchisee && userData.franchisee.id) {
      this.franchiseeID = userData.franchisee.id
    } else {
      Utils.helper.openDrawer(this)
    }
  },
  methods: {
    openInstagramreelsDialog: function () {
      this.instagramDialog = true
      this.requestMode = 'create'
    },
    closeInstagramReelsDialog: function (isApiRequested) {
      this.requestMode = null
      this.instagramDialog = false
      if (isApiRequested) {
        this.getInstagramUrlList(this.franchiseeID)
      }
    },
    getInstagramUrlList: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let apiEndpoint = `${CONSTANTS.API_URL}/api/instaMediaPost/getAllInstaMediaPost`
        let res = await http.get(apiEndpoint)
        if (res.status === 200) {
          console.log('res===>', res)
          res.data.activeInstaPosts.forEach((item, index) => {
            item.indexNo = index + 1

            if (item.startDateAndTime !== null) {
              item.startDateAndTime = moment(item.startDateAndTime).format('YYYY-MM-DD HH:mm:ss')
            } else {
              item.startDateAndTime = ''
            }

            if (item.endDateAndTime !== null) {
              item.endDateAndTime = moment(item.endDateAndTime).format('YYYY-MM-DD HH:mm:ss')
            } else {
              item.endDateAndTime = ''
            }
            if (item.franchiseeID !== null) {
              let franchiseeArray = []
              for (let key in item.franchiseeID) {
                if (item.franchiseeID[key]) {
                  franchiseeArray.push(item.franchiseeID[key])
                }
              }
              item.franchiseeNameArray = franchiseeArray
            } else {
              item.franchiseeNameArray = 'All Franchies'
            }
          })
          this.instagramList = res.data.activeInstaPosts
          this.loadingComponent.close()
        } else {
          this.loadingComponent.close()
          return this.$dialog.message.error(res.data, {
            position: 'top-right',
            color: 'error',
            timeout: 4000
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    deleteIstaUrl: function (instaurlId) {
      this.$dialog.confirm({
        title: 'Deactivate URL?',
        text: 'Are you sure you want to <b>deactivate</b> this URL?',
        actions: {
          false: {
            text: 'No',
            handle: () => {
              this.$nextTick(() => {
                return false
              })
            }
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                this.isLoading = true
                return http
                  .delete(
                    `${CONSTANTS.API_URL}/api/instaMediaPost/deleteInstaMediaPosts/${instaurlId}`
                  )
                  .then((res) => {
                    if (res.status === 200) {
                      this.getInstagramUrlList()
                      this.loadingComponent.close()
                      this.$dialog.message.info(
                        'URL deactivated Successfully',
                        {
                          position: 'top-right',
                          color: 'success',
                          timeout: 4000
                        }
                      )
                    } else {
                      this.loadingComponent.close()
                      this.$dialog.message.error('Failed to deactivate URL.', {
                        position: 'top-right',
                        color: 'error',
                        timeout: 4000
                      })
                    }
                  })
              } catch (e) {
                this.loadingComponent.close()
                this.$dialog.message.info(e.response.data.message, {
                  position: 'top-right',
                  color: 'error',
                  timeout: 4000
                })
              }
            }
          }
        }
      })
    },

    editInstaUrl: function (obj) {
      this.instagramDialog = true
      this.requestMode = 'edit'
      this.instagramItem = obj
      console.log('this.instagramItem', this.instagramItem)
    },

    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
